import {SelectProps, Select} from "antd";
import {useSelector} from "react-redux";
import {RootState} from "../../models";

interface DictSelectProps extends SelectProps {
    dict: string | any;
    appendNull?: boolean;
    nullLabel?: string
}

function initProps():DictSelectProps {
    return {
        dict:{},
        appendNull:true,
        nullLabel: '无'
    }
}

function DictSelect(props: DictSelectProps) {
    const {appendNull, dict, nullLabel, ...otherProps}:DictSelectProps = {...(initProps()),...props};
    const dictState:any = useSelector<RootState>(root=>root.dict);
    let obj:any;
    let disabledOptions:any = {};
    if((typeof dict)=="string"){
        obj = dictState[dict] ?? {};
        disabledOptions = dictState._disabledOptions?.[dict] ?? {};
    }else{
        obj = dict;
    }
    return (
        <Select {...otherProps} placeholder={'请选择'}>
            {appendNull?(<Select.Option key={null} value={null}>{nullLabel}</Select.Option>):null}
            {Object.keys(obj).map(k=>(
                <Select.Option key={k} value={k} disabled={disabledOptions[k]}>
                    {obj[k]}
                </Select.Option>
            ))}
        </Select>
    )
}

export default DictSelect;
